import { Box, Typography } from '@mui/material'
import { footerLinksStyles } from 'src/view/layout/Footer'

function PrivacyPolicy() {
  return (
    <Box sx={footerLinksStyles.container}>
      <Typography variant="h3" sx={footerLinksStyles.heading}>
        Privacy Policy
      </Typography>

      <Typography sx={footerLinksStyles.effectiveDate}>Effective date: March 2, 2026</Typography>

      <Typography sx={footerLinksStyles.paragraph}>
        This Privacy Policy explains how Proxio ("we," "us," "our") collects, uses, and shares information when you use
        proxio.media (the "Site").
      </Typography>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        1) Information we collect
      </Typography>

      <Typography variant="h5" sx={footerLinksStyles.subheading}>
        A. Information you provide
      </Typography>

      <Typography sx={footerLinksStyles.paragraph}>
        Email address and any information you include when you contact us
      </Typography>

      <Typography variant="h5" sx={footerLinksStyles.subheading}>
        B. Information collected automatically
      </Typography>

      <Typography sx={footerLinksStyles.paragraph}>When you visit the Site, we may collect:</Typography>

      <ul>
        <li>Device and browser information</li>
        <li>IP address and approximate location (e.g., city/region)</li>
        <li>Pages viewed, time spent, referral source</li>
        <li>Cookies or similar technologies (see "Cookies" below)</li>
      </ul>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        2) How we use information
      </Typography>

      <Typography sx={footerLinksStyles.paragraph}>We use information to:</Typography>

      <ul>
        <li>Operate, secure, and improve the Site</li>
        <li>Respond to messages and support requests</li>
        <li>Measure performance and understand readership (analytics)</li>
        <li>Prevent fraud, abuse, and security incidents</li>
        <li>Comply with legal obligations</li>
      </ul>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        3) How we share information
      </Typography>

      <Typography sx={footerLinksStyles.paragraph}>We may share information with:</Typography>

      <ul>
        <li>
          Service providers who help us operate the Site (e.g., hosting, analytics, security), under contractual
          obligations to protect the data
        </li>
        <li>Legal and safety recipients if required by law or necessary to protect rights, safety, and integrity</li>
        <li>
          Business transfers if we undergo a merger, acquisition, or sale of assets (information may be transferred as
          part of that transaction)
        </li>
      </ul>

      <Typography sx={footerLinksStyles.paragraph}>
        Proxio does not run advertising on proxio.media and does not sell personal information in exchange for money.
      </Typography>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        4) Cookies and analytics
      </Typography>

      <Typography sx={footerLinksStyles.paragraph}>
        We may use cookies and similar technologies for essential site operation and to understand readership through
        analytics. You can control cookies through your browser settings. Disabling cookies may affect certain site
        functions.
      </Typography>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        5) Your choices and rights
      </Typography>

      <Typography sx={footerLinksStyles.paragraph}>
        Depending on where you live, you may have rights to access, correct, or delete personal information, or to
        object to certain processing. To make a request, contact contact@proxio.media. We may need to verify your
        request consistent with applicable law.
      </Typography>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        6) Data retention
      </Typography>

      <Typography sx={footerLinksStyles.paragraph}>
        We retain information as long as needed to operate the Site, comply with legal obligations, resolve disputes,
        and enforce agreements.
      </Typography>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        7) Security
      </Typography>

      <Typography sx={footerLinksStyles.paragraph}>
        We use reasonable safeguards designed to protect information. No method of transmission or storage is completely
        secure.
      </Typography>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        8) International visitors
      </Typography>

      <Typography sx={footerLinksStyles.paragraph}>
        If you access the Site from outside the British Virgin Islands, your information may be processed in other
        jurisdictions that may have different data protection laws.
      </Typography>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        9) Children's privacy
      </Typography>

      <Typography sx={footerLinksStyles.paragraph}>
        The Site is not directed to children under 13 (or the minimum age required by local law). We do not knowingly
        collect personal information from children.
      </Typography>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        10) Changes to this policy
      </Typography>

      <Typography sx={footerLinksStyles.paragraph}>
        We may update this Privacy Policy from time to time and will update the effective date above.
      </Typography>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        11) Contact
      </Typography>

      <Typography sx={footerLinksStyles.paragraph}>Privacy questions: contact@proxio.media</Typography>
    </Box>
  )
}

export default PrivacyPolicy
